import { render } from "./FlappyBirdPage.vue?vue&type=template&id=c3117b4e"
import script from "./FlappyBirdPage.vue?vue&type=script&lang=js"
export * from "./FlappyBirdPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__